import {
  FETCH_EMP_DISCRIPENCY_REQUEST,
  FETCH_EMP_DISCRIPENCY_SUCCESS,
  FETCH_EMP_DISCRIPENCY_FAILURE,
} from "../constants/EmpDiscripencyConstants";

import EmpDiscripencyService from "../service/EmpDiscripencyService";

export const fetchEmpDiscripency = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EMP_DISCRIPENCY_REQUEST });

    
    const data = await EmpDiscripencyService.getAll(date);

    dispatch({
      type: FETCH_EMP_DISCRIPENCY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_EMP_DISCRIPENCY_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};
